import { withInstall as t } from "../../utils/with-install.js";
import o from "./option.vue.js";
/* empty css            */
const r = t(o);
export {
  r as ApOption,
  r as default
};
